import Vue from "vue";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import "./filter";
import { isCustomer, preventReClick } from "./utils";
// import utils from "./utils/index";
// import ERROR_TYPE from "./config";
import { copyInfo } from "@/utils/commom.js";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer/src/component.vue";
import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);
Vue.use(CoolLightBox);
Vue.prototype.$copyInfo = copyInfo;
Vue.use(preventReClick);
// 初始化对应项目的实例
const project = process.env.VUE_APP_PROJECT;
Vue.use(Viewer);
const { search } = window.location;
let productName;
if (search.match(/productName/)) {
  let strArr = search.slice(1).split("&");
  strArr = strArr.map(ele => {
    return decodeURIComponent(ele);
  });
  strArr.forEach(item => {
    if (item.match(/productName/)) {
      productName = item.split("=")[1];
    }
  });
}
productName = productName ? productName : sessionStorage.getItem("productName");
document.title = isCustomer() ? `专属客服` : `${productName} 客服工作台`;
let vueMachine = undefined;

console.log("===== hai test ====");

const getVueMachine = () => {
  if (vueMachine !== undefined) return vueMachine;
  return import(`./app/${project}/main.js`);
};
getVueMachine().then(async resp => {
  vueMachine = await resp.initVue();
});
// console.log(device)
// const device = utils.getdev();
// 错误日志
// Vue.config.errorHandler = (err, vm, info) => {
//   console.error(`${err.stack}\n\nfound in ${info} of component`);
//   setTimeout(() => {
//     utils
//       .getlog({
//         appId: device,
//         // productId: commonCanstant.PRODUCTID,
//         productId: sessionStorage.getItem("productId"),
//         time: new Date(),
//         lever: ERROR_TYPE.ERROR_TYPE.ERROR,
//         msg: `${err.stack}\n\nfound in ${info} of component`
//       })
//       .then(() => {
//         // console.log(res);
//       });
//   }, 0);
// };
// window.onerror = (message, scriptURI, lineNo, columnNo, error) => {
//   setTimeout(() => {
//     utils
//       .getlog({
//         appId: device,
//         // productId: commonCanstant.PRODUCTID,
//         productId: sessionStorage.getItem("productId"),
//         time: new Date(),
//         lever: ERROR_TYPE.ERROR_TYPE.ERROR,
//         msg: JSON.stringify(
//           `${message}\n\n ${scriptURI} \n\n ${lineNo}\n\n ${columnNo} \n\n ${error}`
//         )
//       })
//       .then(() => {
//         // console.log(res);
//       });
//   }, 0);
// };
// // 警告日志
// Vue.config.warnHandler = (msg, vm, trace) => {
//   console.error(msg);
//   console.error(trace);
//   setTimeout(() => {
//     utils
//       .getlog({
//         appId: device,
//         // productId: commonCanstant.PRODUCTID,
//         productId: sessionStorage.getItem("productId"),
//         time: new Date(),
//         lever: ERROR_TYPE.ERROR_TYPE.WARN,
//         msg: JSON.stringify(msg + "=====" + trace)
//       })
//       .then(() => {
//         // console.log(res);
//       });
//   }, 0);
// };

export default {
  vueMachine,
  getVueMachine
};
